<template>
<svg fill="#000000" width="14px" height="14px" opacity="0.8" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 512 512" xml:space="preserve">
<g>
	<g>
		<path class="color-foreground" d="M455.805,6.244H56.195C25.209,6.244,0,31.453,0,62.439v387.122c0,30.986,25.209,56.195,56.195,56.195h399.61
			c30.987,0,56.195-25.209,56.195-56.195V62.439C512,31.453,486.792,6.244,455.805,6.244z M99.902,468.293H56.195
			c-10.329,0-18.732-8.403-18.732-18.732V156.098h62.439V468.293z M474.537,449.561c0,10.329-8.402,18.732-18.732,18.732H137.366
			V156.098h337.171V449.561z M474.537,118.634H37.463V62.439c0-10.329,8.403-18.732,18.732-18.732h399.61
			c10.33,0,18.732,8.403,18.732,18.732V118.634z"/>
	</g>
</g>
<g>
	<g>
		<rect x="256" y="62.439" width="199.805" height="37.463"/>
	</g>
</g>
<g>
	<g>
		<polygon points="380.882,224.783 300.433,224.764 327.418,251.75 205.292,373.877 231.781,400.367 353.908,278.241 
			380.891,305.223 		"/>
	</g>
</g>
<g>
	<g>
		<circle cx="74.927" cy="81.171" r="24.976"/>
	</g>
</g>
</svg></template>
<script></script>
